"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _peractoUi = require("@peracto/peracto-ui");

var _client = require("@peracto/client");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var RedirectsImportStatusList = function RedirectsImportStatusList(_ref) {
  var data = _ref.data,
      filter = _ref.filter,
      showAll = _ref.showAll;

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      dataModal = _useState2[0],
      setDataModal = _useState2[1];

  var errorColumns = [{
    Header: 'Error Message',
    accessor: 'errors',
    id: 'errorMessage',
    Cell: function Cell(_ref2) {
      var value = _ref2.cell.value;
      return (value === null || value === void 0 ? void 0 : value.length) > 0 ? value[0].message : '-';
    }
  }, {
    Header: 'Error Data',
    accessor: 'errors',
    id: 'errorData',
    Cell: function Cell(_ref3) {
      var _value$0$extra_data, _value$0$extra_data2, _value$0$extra_data2$;

      var value = _ref3.cell.value;
      return (value === null || value === void 0 ? void 0 : value.length) > 0 ? (_value$0$extra_data = value[0].extra_data) !== null && _value$0$extra_data !== void 0 && _value$0$extra_data.errors ? (_value$0$extra_data2 = value[0].extra_data) === null || _value$0$extra_data2 === void 0 ? void 0 : (_value$0$extra_data2$ = _value$0$extra_data2.errors) === null || _value$0$extra_data2$ === void 0 ? void 0 : _value$0$extra_data2$.map(function (error) {
        return /*#__PURE__*/_react["default"].createElement("p", {
          className: "mb-0"
        }, error.property, ": ", error.message);
      }) : value[0].message ? /*#__PURE__*/_react["default"].createElement("p", {
        className: "mb-0"
      }, value[0].message) : '-' : '-';
    }
  }];
  var successColumns = [{
    accessor: 'data',
    Cell: function Cell(_ref4) {
      var value = _ref4.cell.value;
      return /*#__PURE__*/_react["default"].createElement("button", {
        className: "btn btn-link px-0",
        onClick: function onClick() {
          return setDataModal(value);
        }
      }, "Show Data");
    }
  }];
  var additionalColumns = filter.successful ? successColumns : errorColumns;
  var columns = (0, _react.useMemo)(function () {
    return [{
      accessor: 'data',
      id: 'primaryColumn',
      Cell: function Cell(_ref5) {
        var value = _ref5.cell.value;
        return (value === null || value === void 0 ? void 0 : value.fromUrl) || '-';
      }
    }].concat(_toConsumableArray(additionalColumns));
  }, [showAll]);

  var onFetchData = function onFetchData(options) {
    return client(_client.GET_LIST, "import-lines", _objectSpread(_objectSpread({}, options), {}, {
      filter: filter
    }));
  };

  return (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_peractoUi.HydraTable, {
      columns: columns,
      onFetchData: onFetchData,
      noResultsMessage: "No errors!",
      initialData: data
    }), /*#__PURE__*/_react["default"].createElement(_peractoUi.Modal, {
      isVisible: !!dataModal,
      title: "Showing Row Data",
      close: function close() {
        return setDataModal(null);
      },
      buttons: [{
        type: 'btn-outline-secondary',
        text: 'Close',
        action: function action() {
          setDataModal(null);
        }
      }]
    }, !!dataModal && /*#__PURE__*/_react["default"].createElement("table", {
      className: "table table-sm text-left"
    }, Object.entries(dataModal).map(function (entry, idx) {
      return /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("td", {
        className: idx === 0 ? 'border-top-0' : ''
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-weight-bold"
      }, entry[0], ":")), /*#__PURE__*/_react["default"].createElement("td", {
        className: idx === 0 ? 'border-top-0' : ''
      }, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          wordBreak: 'break-all'
        }
      }, entry[1])));
    }))));
  }, [showAll, dataModal]);
};

var _default = RedirectsImportStatusList;
exports["default"] = _default;